<script setup lang="ts">
import { LucideX } from "lucide-vue-next"
import { DialogClose, type DialogCloseProps } from "reka-ui"

const props = defineProps<Omit<DialogCloseProps, "asChild"> & { class?: ClassValue }>()
</script>

<template>
  <DialogClose v-bind="props" as-child>
    <slot>
      <UiButton :class="cn('text-xl', props.class)" variant="icon">
        <slot name="icon">
          <LucideX class="size-font" />
        </slot>

        <span class="sr-only">Close</span>
      </UiButton>
    </slot>
  </DialogClose>
</template>
